import { IconArrowLeft, IconCrossLarge } from '@tock/icons';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  onDigitEntered(digit: string): void;
  onBackspace(): void;
  onClear(): void;
}

const LAYOUT = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
];

export default class PasscodeKeypad extends PureBaseComponent<Props> {
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Backspace') {
      this.props.onBackspace();
    } else if (!isNaN(parseInt(e.key, 10))) {
      this.props.onDigitEntered(e.key);
    }
  }

  onDigitClick(digit: string) {
    return () => {
      this.props.onDigitEntered(digit);
    };
  }

  render() {
    return (
      <div className="PasscodeKeypad">
        {LAYOUT.map((row, i) => (
          <div key={i} className="PasscodeKeypad-row">
            {row.map((num, j) => (
              <div
                key={j}
                className="PasscodeKeypad-key"
                onClick={this.onDigitClick(num)}
                data-testid={'passcode_' + num}
              >
                {num}
              </div>
            ))}
          </div>
        ))}
        <div className="PasscodeKeypad-row">
          <div className="PasscodeKeypad-key" onClick={this.props.onClear}>
            <IconCrossLarge />
          </div>
          <div className="PasscodeKeypad-key" onClick={this.onDigitClick('0')}>
            0
          </div>
          <div className="PasscodeKeypad-key" onClick={this.props.onBackspace}>
            <IconArrowLeft />
          </div>
        </div>
      </div>
    );
  }
}
